<template>
    <v-app id="solutions">
        <v-content class="container mx-auto">
            <program-list />
        </v-content>
    </v-app>
</template>

<script>
import ProgramList from "./views/ProgramList";

export default {
    components: {
        ProgramList
    }
};
</script>
